import { useMemo } from 'react';
import type { WidgetRow } from '../hooks/integrations/externalIntegrationTypes';
import { translateTags } from './UiWidgetHelpers';

const useTagTranslator = (row: WidgetRow['settings'], dataSource: any, settings: any, field: string = 'text') => {
	let text = row[field] ?? '';
	if (row.index !== undefined) {
		text = text.replace(/\{\{index\}\}/g, row.index);
	}

	const translatedText = useMemo(() => translateTags(text, dataSource, { settings }), [dataSource, settings, text]);

	return translatedText;
};

export default useTagTranslator;
